<template>
    <el-container style="height:89vh;">
      <el-container>
        <el-main>
         <appMain />
        </el-main>
      </el-container>
    </el-container>
</template>

<script>
import appMain from './components/appMain' // 侧边栏

export default {
  name: 'News',
  components: {
    appMain
  }
}
</script>

<style lang="less" scoped>
</style>
